import { Button, Col, Form, Input, Row } from "antd";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { notificationError, notificationInfo } from "utils/libHelpers/AntdNotification";

interface ProjectProfileFormProps extends ModalComponentProps {
  initialData: API_LinkedUserDetails["userContactData"];
  onSubmit: (values: API_LinkedUserDetails["userContactData"]) => Promise<void>;
}

export const ProjectProfileForm: FunctionComponent<ProjectProfileFormProps> = ({
  hideModal,
  initialData,
  onSubmit,
}) => {
  const { t } = useTranslation(I18N_NS.ADMIN);

  const handleSubmit = async (values: API_LinkedUserDetails["userContactData"]) => {
    try {
      await onSubmit(values);
      hideModal();
    } catch (error) {
      if (error?.response?.data?.code === 2) {
        notificationInfo(t("Please note"), error.response.data.message, 0);
        hideModal();
      } else {
        notificationError(t("Error"), t("Settings could not be saved"));
        throw error;
      }
    }
  };

  return (
    <Form onFinish={handleSubmit} initialValues={initialData} layout="vertical">
      <Row gutter={10}>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Company")} name="companyName">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Position")} name="companyRole">
            <Input />
          </Form.Item>
        </Col>
        {/* <Col xs={24} lg={12}>
          <Form.Item
            label={t("Firstname")}
            name="firstname"
            rules={[{ required: true, message: t("This field is required") }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item
            label={t("Lastname")}
            name="name"
            rules={[{ required: true, message: t("This field is required") }]}
          >
            <Input />
          </Form.Item>
        </Col> */}
        <Col xs={24} lg={12}>
          <Form.Item
            label={t("Email")}
            name="email"
            rules={[{ type: "email", required: true, message: t("Email is not valid") }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Phone")} name="phoneNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Mobile")} name="mobileNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Fax")} name="fax">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Street")} name="street">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("City")} name="city">
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item label={t("Zip")} name="postalCode">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <div className="text-right">
        <Button type="primary" htmlType="submit">
          {t("Save")}
        </Button>
      </div>
    </Form>
  );
};
